export const SYMPTOM_OPTIONS = [
  "Darmbeschwerden",
  "Chronische Infekte",
  "Urogenitale Beschwerden",
  "Hautbeschwerden",
  "Erschöpfung / Energiemangel",
  "Hormonelle Beschwerden",
  "Nahrungsmittelunverträglichkeiten",
  "Rheumatologische Beschwerden",
  "Gynäkologische Beschwerden",
  "Schmerzsymptomatik ohne Befund",
  "Bakteriophagentherapie / Eliava Institut – erste Abklärung, Einordnung und Informationen",
  "MicrogenDX qPCR / NGS Testing",
  "Unklare Beschwerden",
  "Sonstiges",
] as const;

export type AppointmentMode = "praxis" | "zoom";
export type SlotStatus = "open" | "booked" | "blocked" | "auto_closed";
export type BookingStatus = "pending" | "confirmed" | "cancelled";

export const modeLabel: Record<AppointmentMode, string> = {
  praxis: "Praxis",
  zoom: "Zoom",
};

export const slotStatusLabel: Record<SlotStatus, string> = {
  open: "Frei",
  booked: "Gebucht",
  blocked: "Gesperrt",
  auto_closed: "Automatisch gesperrt",
};

export const bookingStatusLabel: Record<BookingStatus, string> = {
  pending: "Angefragt",
  confirmed: "Bestätigt",
  cancelled: "Abgesagt",
};

const dateFmt = new Intl.DateTimeFormat("de-AT", {
  weekday: "long",
  day: "2-digit",
  month: "long",
  year: "numeric",
  timeZone: "Europe/Vienna",
});

const timeFmt = new Intl.DateTimeFormat("de-AT", {
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Europe/Vienna",
});

export const formatSlotDate = (iso: string) => dateFmt.format(new Date(iso));
export const formatSlotTime = (iso: string) => `${timeFmt.format(new Date(iso))} Uhr`;

/** Lokaler Tagesschlüssel (YYYY-MM-DD) für Gruppierung */
export const dayKey = (iso: string) => {
  const d = new Date(iso);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
